export default __webpack_public_path__ + "static/media/sunset.30aa00a2.png";